import dataType from '../dataType';

const exchangeRates = {
    name: 'ExchangeRates',
    type: dataType.string
};

export default exchangeRates;
